import React from 'react';
import { Grid } from '@material-ui/core';
import { Text, CircularIcon, Colors } from 'library';
import { NextStepType } from '../IndeedModels';

const LogoTextPair = ({ icon, text, title, gridStyle = {} }: NextStepType) => {
    return (
        <Grid
            item
            container
            xs={12}
            alignItems={!!title ? 'flex-start' : 'center'}
            direction="row"
            style={{ width: '100%' }}
        >
            <Grid item container sm={2} xs={2} justify="flex-end">
                <CircularIcon
                    backgroundColor={Colors.lightTurq}
                    icon={icon}
                    style={{ height: 40, width: 40, marginRight: 10 }}
                    padding={0}
                />
            </Grid>
            <Grid item sm={10} xs={10} style={gridStyle}>
                {!!title ? (
                    <Grid container>
                        <Grid item>
                            <Text variant="body1" color={Colors.turquoise} bold>
                                {title}
                            </Text>
                        </Grid>
                        <Grid item>
                            <Text variant="body3">{text}</Text>
                        </Grid>
                    </Grid>
                ) : (
                    <Text variant="body1">{text}</Text>
                )}
            </Grid>
        </Grid>
    );
};

export default LogoTextPair;
